var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0896 0.812556C11.4117 0.810375 11.7311 0.872048 12.0293 0.994014C12.3275 1.11598 12.5986 1.29582 12.8269 1.52315L12.43 1.92174L12.8285 1.5247C13.0559 1.75293 13.2358 2.02397 13.3578 2.32216C13.4799 2.62035 13.5416 2.93977 13.5394 3.26195C13.5372 3.58413 13.4712 3.90268 13.3451 4.19919C13.2195 4.49462 13.0368 4.76232 12.8075 4.98694L5.33315 12.4613C5.26188 12.5326 5.17278 12.5834 5.07515 12.6084L1.51476 13.5216C1.3222 13.571 1.11787 13.5151 0.977292 13.3745C0.836714 13.234 0.780767 13.0296 0.830129 12.8371L1.74279 9.27668C1.76782 9.17902 1.81864 9.08989 1.88992 9.0186L9.36435 1.54418C9.58906 1.31492 9.85683 1.13227 10.1523 1.00672C10.4488 0.880729 10.7674 0.814737 11.0896 0.812556ZM12.0323 2.31956C11.9095 2.19746 11.7637 2.10085 11.6034 2.03528C11.4428 1.96958 11.2707 1.93636 11.0972 1.93753C10.9236 1.93871 10.752 1.97426 10.5923 2.04213C10.4325 2.11 10.2878 2.20886 10.1665 2.33298L10.162 2.33756L2.79431 9.7052L2.15589 12.1958L4.64652 11.557L12.0189 4.18458C12.143 4.06335 12.2419 3.91874 12.3098 3.75906C12.3777 3.59938 12.4132 3.42783 12.4144 3.25433C12.4156 3.08083 12.3823 2.90881 12.3166 2.74823C12.2511 2.58799 12.1544 2.4423 12.0323 2.31956Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename_icon.d5c26eb9fcc140618b60b96b0a2242a5.svg";
export { ForwardRef as ReactComponent };